
const state = {
  id: null,
  entity_type: '',
  key: '',
  owner_id: undefined,
  owner_type: '',
}

export const requiredFields = [
  { key: 'entity_type' },
  { key: 'owner_id' },
  { key: 'owner_type' },
]

export default state
